import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import WalletModal from "../common/WalletModal";
import Modal from "react-bootstrap/Modal";
import Offcanvas from "react-bootstrap/Offcanvas";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useAccount } from "wagmi";

function ReferralModal(props) {
  const { address } = useAccount();

  const handleCopy = () => {
    if (address) {
      navigator.clipboard.writeText(address);
      toast.success("Address copied to clipboard!");
    }
  };

  return (
    <Modal className="wallet-modal" {...props} size="lg" centered>
      <Modal.Header>
        <IoCloseCircleOutline onClick={props.onHide} />
      </Modal.Header>
      <Modal.Body className="px-5">
        <div className="wallet-main referral-main">
          <h4>Referral Link</h4>
          <p>
            Share the link below with your friends and earn 5% from each
            purchase they make.
          </p>
          <div className="form">
            <div>
              {address ? (
                <h4>{address}</h4>
              ) : (
                <h4>Please connect your wallet</h4>
              )}
            </div>
            <div>
              <button className="btn" onClick={handleCopy} disabled={!address}>
                Copy
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="m-0">Share your link on</p>
            <ul className="list-inline d-flex p-0 m-0">
              <li>
                <a href="https://x.com/PlayappEconomy">
                  <img src="/images/Twitter.png" alt="Twitter" />
                </a>
              </li>
              <li>
                <a href="https://t.me/+2El92idV0yBjZmM0">
                  <img src="/images/Telegram.png" alt="Telegram" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

const Header = () => {
  const [modalShow, setModalShow] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleScroll = (id) => {
    setShowOffcanvas(false); // Close offcanvas first

    // Wait for offcanvas to close before scrolling
    setTimeout(() => {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 300); // Adjust delay based on your Offcanvas close animation duration
  };

  return (
    <>
      <ToastContainer />
      <ReferralModal show={modalShow} onHide={() => setModalShow(false)} />

      <Navbar expand="xl" className="custom-header">
        <Container>
          <div className="header w-100 d-flex justify-content-between align-items-center">
            <Navbar.Brand>
              <Link to="/">
                <img src="/images/logo.png" alt="logo" />
              </Link>
            </Navbar.Brand>

            {/* Toggle only for mobile */}
            <div className="d-xl-none">
              <Navbar.Toggle
                aria-controls="offcanvasNavbar"
                onClick={() => setShowOffcanvas(true)}
              />
            </div>

            {/* Desktop Nav */}
            <Navbar.Collapse id="basic-navbar-nav" className="d-none d-xl-flex">
              <div
                style={{
                  width: 1,
                  height: 23,
                  background:
                    "var(--color-white--30%, rgba(255, 255, 255, 0.30))",
                }}
              />{" "}
              <Nav className="me-auto">
                {[
                  // "aboutus",
                  "tokenomics",

                  // "documentation",
                  "roadmap",
                  "faq",
                  // "teams",
                  // "staking",
                  // "contactus",
                ].map((id) => (
                  <span
                    role="button"
                    className="nav-link"
                    onClick={() => handleScroll(id)}
                  >
                    {id}
                  </span>
                ))}
                <Link className="nav-link" to="/howitworks">How It Works</Link>
              </Nav>
              <div className="gap-md d-flex align-items-center btn-t-m gap-3">
                <WalletModal />
                {/* <select className="form-select language">
                  <option value="">AR</option>
                  <option value="">EN</option>
                </select> */}
              </div>
            </Navbar.Collapse>
          </div>
        </Container>
      </Navbar>

      <Offcanvas
        show={showOffcanvas}
        onHide={() => setShowOffcanvas(false)}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Link to="/">
            <img src="/images/logo.png" alt="logo" />
          </Link>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            {[
              // "aboutus",
              "tokenomics",
              // "documentation",
              "roadmap",
              "faq",
              // "teams",
              // "staking",
              // "contactus",
            ].map((id) => (
              <span
                role="button"
                className="nav-link"
                onClick={() => handleScroll(id)}
              >
                {id.toUpperCase()}
              </span>
            ))}
            <Link className="nav-link" to="/howitworks">How It Works</Link>
            <div className="gap-md d-flex align-items-center px-3 btn-t-m gap-3">
              <WalletModal />
              {/* <select className="form-select language">
                  <option value="">AR</option>
                  <option value="">EN</option>
                </select> */}
            </div>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Header;
